import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

export const organizationGuard: CanActivateFn = (activatedRoute: ActivatedRouteSnapshot) => {
	const userService = inject(UserService);
	const router = inject(Router);
	const stringId = activatedRoute.paramMap.get('id');
	if (stringId === null) {
		return router.createUrlTree(['/']);
	}
	if (!userService.user.hasAccessToOrganizations(Number(stringId))) {
		return router.createUrlTree(['/']);
	}
	return true;
};
